import { api } from '@/lib/api'
import type { Reminder } from '@/lib/types'

export type { Reminder }

export async function listReminders(
  accountId: string,
  opts?: { done?: boolean },
): Promise<Reminder[]> {
  const params = new URLSearchParams({ accountId })
  if (opts?.done !== undefined) params.set('done', String(opts.done))
  return api<Reminder[]>(`/reminders?${params}`)
}

export async function createReminder(
  accountId: string,
  data: {
    text: string
    notes?: string | null
    dueAt?: string | null
    remindAt?: string | null
    recurrence?: string
    customerId?: string
    jobId?: string
  },
): Promise<Reminder> {
  return api<Reminder>(`/reminders?accountId=${accountId}`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export async function updateReminder(
  id: string,
  accountId: string,
  updates: {
    text?: string
    notes?: string | null
    dueAt?: string | null
    remindAt?: string | null
    recurrence?: string
    done?: boolean
  },
): Promise<void> {
  await api(`/reminders/${id}?accountId=${accountId}`, {
    method: 'PATCH',
    body: JSON.stringify(updates),
  })
}

export async function deleteReminder(id: string, accountId: string): Promise<void> {
  await api(`/reminders/${id}?accountId=${accountId}`, { method: 'DELETE' })
}
